import React from 'react'
import Link from 'gatsby-link'
import { siteMetadata } from '../../gatsby-config'
import SiteNavi from '../components/SiteNavi'
import emergence from 'emergence.js'
import Amplify from 'aws-amplify'
import { I18n } from 'aws-amplify'
import aws_exports from '../aws-exports'
import { Auth } from 'aws-amplify'

import './gatstrap.scss'
import 'animate.css/animate.css'
import 'prismjs/themes/prism-okaidia.css'
import 'devicon-2.2/devicon.min.css'
import 'font-awesome/css/font-awesome.css'
import { connect } from 'react-redux'

const dict = {
  sv: {
    'Sign In': 'Logga in',
    'Sign Up': 'Registrera',
    'Sign Out': 'Logga ut',
    'Forgot Password': 'Glömt lösenord',
    'Username cannot be empty': 'Användarnamn kan inte vara tomt',
    'User does not exist.': 'Användaren finns inte.',
    Username: 'Användarnamn',
    Password: 'Lösenord',
    'Change Password': 'Byt lösenord',
    'New Password': 'Nytt lösenord',
    Email: 'Epost',
    'Phone Number': 'Telefonnummer',
    'Confirm a Code': 'Bekräfta kod',
    'Confirm Sign In': 'Bekräfta inloggning',
    'Confirm Sign Up': 'Bekräfta registrering',
    'Back to Sign In': 'Tillbaks till inloggning',
    'Send Code': 'Skicka kod',
    Confirm: 'Bekräfta',
    'Resend a Code': 'Skicka kod igen',
    Submit: 'Skicka',
    Skip: 'Hoppa över',
    Verify: 'Verifiera',
    'Verify Contact': 'Verifiera kontakt',
    Code: 'Kod',
    'Account recovery requires verified contact information':
      'Återställning av konto kräver verifierad kontaktinformation',

    'User does not exist': 'Användaren finns inte',
    'User already exists': 'Användaren finns redan',
    'Incorrect username or password': 'Ogiltigt användarnamn eller lösenord',
    'Invalid password format': 'Ogiltigt lösenordsformat',
    'Invalid phone number format': 'Ogiltigt telefonnummer',
  },
}

Amplify.configure(aws_exports)
I18n.putVocabularies(dict)
I18n.setLanguage('sv')

class Template extends React.Component {
  componentWillMount() {
    Auth.currentAuthenticatedUser()
      .then(user => this.props.user(user))
      .catch(err => console.error('could not get current user', err))
  }

  componentDidMount() {
    emergence.init()
  }

  componentDidUpdate() {
    emergence.init()
  }

  render() {
    const { location, children } = this.props
    return (
      <div>
        <SiteNavi title={siteMetadata.title} {...this.props} />
        {children()}
      </div>
    )
  }
}

const mapStateToProps = ({ count }) => {
  return { count }
}

const mapDispatchToProps = dispatch => {
  return { user: user => dispatch({ type: `USER`, user }) }
}

const ConnectedTemplate = connect(mapStateToProps, mapDispatchToProps)(Template)

export default ConnectedTemplate



// WEBPACK FOOTER //
// ./src/layouts/index.js